import React from "react";
import { Link } from "react-router-dom";
import { SEO_LINKS } from "../../config/site";
import { Reveal, useEnquiry } from "../../lib/site-ui";

const linkCls = "text-white underline decoration-white/30 underline-offset-4 hover:decoration-white transition-colors";

export const SeoContent = () => {
  const { openEnquiry } = useEnquiry();
  return (
    <section id="about-dgca" className="py-24 sm:py-32 lg:py-40 border-t border-white/10" data-testid="seo-content-section">
      <div className="max-w-4xl mx-auto px-4 sm:px-8">
        <Reveal as="p" className="label-mono text-slate-500 mb-4">08 — Overview</Reveal>
        <Reveal as="h2" className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight text-white mb-8">
          DGCA Ground Classes in Mumbai &amp; Online Across India
        </Reveal>
        <Reveal>
          <div className="space-y-5 text-slate-300 leading-relaxed text-lg">
            <p>
              AeroVaid Aviation Academy provides DGCA ground coaching designed around one idea — helping aspiring
              pilots genuinely understand the concepts rather than memorise them. If you are based in the city, you can
              choose{" "}
              <Link to={SEO_LINKS.mumbai} className={linkCls}>personalised DGCA ground classes in Mumbai</Link>, with
              one-to-one sessions arranged around your schedule. Students anywhere else can join our{" "}
              <Link to={SEO_LINKS.online} className={linkCls}>online DGCA ground classes</Link> with live instruction
              and real doubt support.
            </p>
            <p>
              Our preparation covers all six ground subjects — Air Regulations, Air Navigation, Meteorology, Technical
              General, Technical Specific and RTR — taught with a concept-based approach focused on how the DGCA
              examinations actually test you. You can explore the full{" "}
              <a href="#courses" className={linkCls}>DGCA subjects</a> we cover, review our transparent{" "}
              <a href="#pricing" className={linkCls}>founding-batch pricing</a>, or read about the{" "}
              <a href="#founder" className={linkCls}>instructor behind AeroVaid</a>.
            </p>
            <p>
              Not sure yet? Every student is welcome to{" "}
              <button onClick={() => openEnquiry()} className={linkCls} data-testid="seo-demo-link">
                book a free demo class
              </button>{" "}
              and experience the teaching before enrolling. AeroVaid is based in Mumbai, Maharashtra, and works with
              serious aspiring pilots across India.
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
